import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { HrisDepartmentList } from '../../../../entities/v1/HrisDepartmentList';

export interface ListParams {
  name?: string;
  page?: number;
  pageSize?: number;
}

export class HrisDepartmentService {
  public static list(params: ListParams) {
    return ApiService.get<HrisDepartmentList>(
      '/api/v1/applicant_tracking/hris_departments',
      snakecaseKeys(params),
    );
  }
}
